import { Navigate } from 'react-router-dom'
import { useCompetitions } from '@/features/competitions/api'
import { useSession } from '@/features/session/use-session'
import { resolveSignedInHome } from '@/lib/role-routing'

/**
 * `/app` — the "just authenticated, where do I belong" resolution target.
 * Nothing in normal navigation links here; only a successful login (and dev
 * sign-in) land on it, then immediately move on.
 *
 * PR-053 (v3.1.2, TASK-U-009): this used to be `/`'s own route element
 * (`RootRedirectPage`), so visiting the site's root as a signed-in visitor
 * skipped straight to a role's workspace instead of the public landing
 * content — the exact "首頁 isn't really 首頁 once you're logged in" report
 * this task fixes. The role-resolution logic itself (`resolveSignedInHome`)
 * is unchanged and still valuable — it is what gets a returning judge/admin
 * straight to their work after signing in — it is just triggered from the
 * moment of authentication (`login-page.tsx`, `dev-sign-in-card.tsx`) rather
 * than from every visit to `/`.
 */
export function SignedInLandingPage() {
  const session = useSession()
  const authenticated = session.data?.authenticated === true

  const competitions = useCompetitions()

  if (session.isPending) {
    return null
  }

  if (!authenticated) {
    return <Navigate to="/" replace />
  }

  if (competitions.isPending) {
    return null
  }

  const home = resolveSignedInHome(
    session.data?.user?.globalRole ?? 'user',
    competitions.data ?? [],
  )
  return <Navigate to={home} replace />
}
